import config from '../config';

export const injectLiveChat = () => {
  if(config.env !== `prod`) {
    return;
  }

  const body = document.getElementsByTagName(`body`);
  if(body.length) {
    const liveChatScript = document.createElement(`script`);
    const textNode = document.createTextNode(
      `window.__lc = window.__lc || {};
      window.__lc.license = 10865982;
      (function() {
        var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true;
        lc.src = 'https://cdn.livechatinc.com/tracking.js';
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s);
      })();`
    );
    liveChatScript.appendChild(textNode);
    body[0].appendChild(liveChatScript);
  }
};



// WEBPACK FOOTER //
// ./client/services/livechat.js